import { DEVICES_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const devicesApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDevices: builder.query({
            query: () => ({
                url: DEVICES_URL,
            }),
            keepUnusedDataFor:5
        }),
        getDevicesBySite: builder.query({
            query: (siteId) => ({
                url: `${DEVICES_URL}/site/${siteId}`,
            }),
            invalidatesTags:['Devices']
        }),
        getPhones: builder.query({
            query: () => ({
                url: `${DEVICES_URL}/phones`,
            }),
            keepUnusedDataFor:5
        }),
        getIsp: builder.query({
            query: () => ({
                url: `${DEVICES_URL}/isp`,
            }),
            keepUnusedDataFor:5
        }),
        getDeviceDetails: builder.query({
            query: (deviceId) => ({
                url: `${DEVICES_URL}/${deviceId}`,
            }),
            keepUnusedDataFor:5
        }),
        createDevice: builder.mutation({
            query: (data) => ({
                url: DEVICES_URL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags:['Devices']
        }),
        updateDevice: builder.mutation({
            query: (data) => ({
                url: `${DEVICES_URL}/${data._id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags:['Devices']
        }),
        deleteDevice: builder.mutation({
            query: (deviceId) => ({
                url: `${DEVICES_URL}/${deviceId}`,
                method: 'DELETE',
            }),
        }),
        getDeviceList: builder.mutation({
            query: (data) => ({
                url: `${DEVICES_URL}/deviceList`,
                method: 'POST',
                body: data,
            })
        }),
        uploadCSV: builder.mutation({
            query: (data) => ({
                url: `${DEVICES_URL}/upload-csv`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Devices']
        }),
        uploadCellphones: builder.mutation({
            query: (data) => ({
                url: `${DEVICES_URL}/upload-cellphones`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Devices']
        })
    })
});

export const {
    useGetDevicesQuery, 
    useGetPhonesQuery, 
    useGetIspQuery, 
    useCreateDeviceMutation, 
    useUpdateDeviceMutation, 
    useDeleteDeviceMutation, 
    useGetDeviceListMutation, 
    useGetDevicesBySiteQuery,
    useUploadCSVMutation,
    useUploadCellphonesMutation
} = devicesApiSlice;
